import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import SessionRouter from './SessionRouter/SessionRouter';
import { routes } from './routes';
import { HostedSessionOutcome } from './HostedSessionOutcome';

/**
 * Checks if the route is a session router path.
 * Supports versioned paths like /v2/app, /v3/app as well as /app.
 */
const isSessionRouterPath = (route: string): boolean => {
  const SESSION_ROUTER_PATTERN = /^(\/v\d+)?\/app$/;
  return SESSION_ROUTER_PATTERN.test(route);
};

/**
 * Like `<BrowserRouter`, but with a fallback to `<SessionRouter>` if the
 * `uiRoute` is a session router path (/app, /v2/app, /v3/app, etc.).
 *
 * UnifiedRouter's goal is to always answer the question:
 *   "What ui screen/form/page should the user see at any given moment?"
 *
 * It does this by taking into account all variables, and
 * determining a URL to send the user to.
 *
 *   Each url should have no more than 1 required "form" with 1 "submit" button/action
 *   - Optional submit/actions can be ignored
 *   - pages with multiple forms should have multiple urls (/part/1, /part/2, etc)
 *   - Is it hosted or embedded?
 */
export const UnifiedRouter = ({
  uiRoute = window.location.pathname,
}: {
  uiRoute?: string;
}) => {
  if (isSessionRouterPath(uiRoute)) {
    return <SessionRouter />;
  }

  /** @deprecated: planned to be removed on a future date (was used for guest mode) */
  return (
    <HostedSessionOutcome>
      <BrowserRouter>{routes}</BrowserRouter>
    </HostedSessionOutcome>
  );
};
